import { toast } from '@/composables/useAlertToast';

export class ApiError extends Error {
  constructor(message, statusCode, data) {
    super(message);
    this.statusCode = statusCode;
    this.data = data;
  }
}

export const handleApiError = async (
  error,
  context = '',
  toasty = true,
  overrideMessage = null
) => {
  const DEFAULT_MESSAGE = 'An error occurred';
  let message = DEFAULT_MESSAGE;
  let statusCode = 500;

  try {
    if (error.response) {
      statusCode = error.response.status;

      try {
        const text = await error.response.text();
        try {
          const errorBody = JSON.parse(text);
          message = errorBody.message || errorBody.error || message;
        } catch {
          message = error.response.statusText || message;
        }
      } catch {
        message = error.response.statusText || message;
      }

      // Handle specific status codes globally
      if (statusCode === 401) {
        message = 'Your session has expired. Please log in again.';
      } else if (statusCode === 403) {
        message = 'You do not have permission to perform this action.';
      } else if (statusCode === 404) {
        message = 'The requested resource was not found.';
      } else if (statusCode >= 500) {
        message = 'Service unavailable. Please try again later.';
      }
    } else if (error.message) {
      message = error.message;
    }
  } catch (e) {
    console.error('Error parsing error response:', e);
  }

  // Use overrideMessage if provided
  const userMessage = overrideMessage
    ? overrideMessage
    : message || DEFAULT_MESSAGE;

  // Log for debugging
  console.error(`[${context}] API Error:`, {
    statusCode,
    message: userMessage,
    originalError: error,
  });

  // Show toast to user
  if (toasty) {
    toast.error(userMessage);
  }

  // Throw standardized error
  throw new ApiError(userMessage, statusCode, error);
};
